import { ETH_ADDRESS } from '@bitly/sdk/constants'
import { TokenInfoTypeWithAddress } from '@bitly/sdk/types'

export const ENS_REVERSE_LOOKUP = '0x3671aE578E63FdF66ad4F3E12CC0c0d71Ac7510C'

export const ETH_TOKEN_INFO: TokenInfoTypeWithAddress = {
	address: ETH_ADDRESS,
    description: "Ethereum is the native cryptocurrency of the ETH network.",
    url: "https://ethereum.org/",
    logo: "https://token.bitly.exchange/images/tokens/eth.png",
    name: "Ethereum",
    symbol: "ETH",
    decimals: 18,
    rule: ETH_ADDRESS,
    pairs: [],
} as unknown as TokenInfoTypeWithAddress